import type { ProjectVariable } from "../../../Admin/ProfessionalServices/common/types/ProjectVariable";

// project-variables on a v2 governance embeds each governance-context
// definition with its value but no id; ProjectVariablesV2 wants the app's
// ProjectVariable shape.
export const governanceVariablesFromApi = (raw: unknown): ProjectVariable[] =>
  Array.isArray(raw)
    ? raw.map((variable: any) => ({
        ...variable,
        id: variable?.name ?? "",
        select_options: variable?.select_options ?? [],
        "select-options": variable?.["select-options"] ?? [],
        value: variable?.value ?? "",
      }))
    : [];

// The embedded type declares value a string; a blank field sends "", as
// the legacy form's empty inputs did.
export const governanceVariablesToApi = (variables: ProjectVariable[]) =>
  variables.map(({ name, value }) => ({
    name,
    value: value == null ? "" : String(value),
  }));
